export type CsvParseError = "invalid" | "rowLimitExceeded" | "empty";

export class RowLimitExceededError extends Error {}
